import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { InstitutionGroup } from './InstitutionGroup';
import { InstitutionMember } from './InstitutionMember';
import { GROUPS_I_AM_ADMIN_OF } from './SecurityRules';

export interface InstitutionGroupMemberRow {
  id: number;
  institution_group_id: number;
  institution_member_id: number;
  created_at: string;
}

export const InstitutionGroupMember: Entity<InstitutionGroupMemberRow> = {
  id: 'InstitutionGroupMember',
  title: 'Institution Group Member',
  service: 'main',
  rowLabel: (row: InstitutionGroupMemberRow) => [row.institution_group_id, row.institution_member_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupMemberRow) =>
    `<lookup:InstitutionMember:${row.institution_member_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_member',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_group_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      listColumn: true,
      refEntity: InstitutionGroup,
    },
    institution_member_id: {
      seq: 15,
      label: 'Institution Member',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: InstitutionMember,
    },
    created_at: {
      seq: 20,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
